export const TINYMCE_PREVENT_BLUR_CLASSNAME = 'mce-prevent-blur';